import { useSelector } from "react-redux"
import { getRebalanceDate } from "modules/rebalance/selectors"
import { createDateAdapter } from "./create-date-adapter"

export const withRebalanceDates = createDateAdapter(() => {
  const rebalanceDate = useSelector(getRebalanceDate)
  return { startDate: rebalanceDate, endDate: rebalanceDate }
})
